import React from 'react';
import {Grid, useMediaQuery} from "@mui/material";
import DownloadCSVButton from "../../report/export/DownloadCSVButton";
import {
  getBuyerInterChangeReportUrl,
  getBuyerInterChangeSummaryReportUrl
} from "../requests/buyer-interchanges-requests";

const BuyerInterChangeExportCSVs = (props) => {
  const { item, query, className } = props;
  const isMd = useMediaQuery(theme => theme.breakpoints.up('md'));

  return (
    <Grid item={item} container gap={4} justifyContent={isMd ? 'flex-end' : 'space-between'} xs={12} md>
      <Grid item>
        <DownloadCSVButton
          reportUrl={getBuyerInterChangeSummaryReportUrl(query)}
          title={'Download Summary'}
          className={className}/>
      </Grid>
      <Grid item>
        <DownloadCSVButton
          reportUrl={getBuyerInterChangeReportUrl(query)}
          title={'Download Report'}
          className={className}/>
      </Grid>
    </Grid>
  )
};

export default BuyerInterChangeExportCSVs;
